type ShouldShowNonPlayingHostMenuItemParams = {
  memberNonPlayingHostToggle: boolean;
  isMember: boolean;
  isEditRoundsPrivateStep: boolean;
  isAllMemberGroup: boolean;
};

export const shouldShowNonPlayingHostMenuItem = ({
  memberNonPlayingHostToggle,
  isMember,
  isEditRoundsPrivateStep,
  isAllMemberGroup,
}: ShouldShowNonPlayingHostMenuItemParams) =>
  memberNonPlayingHostToggle &&
  isMember &&
  isEditRoundsPrivateStep &&
  !isAllMemberGroup;
